// import { SelectOption } from "components/dropdown/Dropdown";
import { useField, useFormikContext } from "formik";
import { SetStateAction, useCallback, useEffect, useState } from "react";

import { MultiSelectOption } from "../../../dropdown/MultiDropdown";

import Select, { components } from "react-select";
import { ValueType } from "react-select/src/types";
import api from "api";
import { debounce } from "lodash";
import { useOnceAfterCondition } from "helpers/useOnceAfterCondition";
import { Option } from "react-select/src/filters";
import {
  DragDropContext,
  Draggable,
  DropResult,
  Droppable,
  ResponderProvided,
} from "react-beautiful-dnd";
import dragIcon from "assets/Icon_Toggle_List_01.png";
import _ from "lodash";
import { customUseOnClickOutside } from "./SearchListRenderer";

const capitaliseFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export type SelectOptionOrderNumbers = {
  label: string;
  value: any;
  orderNumber: number;
};

const compareArrayofObjects = function(x: any[] | null, y: any[] | null) {
  if (Array.isArray(x) && Array.isArray(y)) {
    const isSameSize = _.size(x) === _.size(y);
    return (
      isSameSize &&
      _(x)
        .xorWith(y, _.isEqual)
        .isEmpty()
    );
  } else {
    if (!x && !y) {
      return true;
    } else {
      return false;
    }
  }
};

const sortByOrderNumber = (data: SelectOptionOrderNumbers[]) => {
  const unorderedItems = data.filter(item => item.orderNumber === -1);

  let orderedItems = data.filter(item => item.orderNumber !== -1);

  orderedItems.sort((a, b) => a.orderNumber - b.orderNumber);

  orderedItems = [...orderedItems, ...unorderedItems];

  orderedItems = orderedItems.map((item, idx) => {
    return { ...item, orderNumber: idx + 1 };
  });

  return orderedItems;
};

const reorder = (values: any, oldIndex: number, newIndex: number) => {
  let result = [...values];

  const movedElement = result[oldIndex];

  result.splice(oldIndex, 1);

  result.splice(newIndex, 0, movedElement);

  return result;
};

const getItemStyle = (isDragging: any, draggableStyle: any) => ({
  ...draggableStyle,
});

const CustomControl: React.FC<any> = props => {
  const orderingComponent = props?.selectProps?.selectProps?.orderingComponent;
  const isDragging = props?.selectProps?.selectProps?.isDragging;
  const setMenuOpen = props?.selectProps?.selectProps?.setMenuOpen;
  const menuOpen = props?.selectProps?.selectProps?.menuOpen;
  const selectProps = props?.selectProps?.selectProps;

  return (
    <components.Control {...props}>
      <div
        className={"customControl"}
        // NOTE: Not needed as it accidentally closes the menu on desktop straight away after opening
        // onClick={() => {
        //   // Stop menu opening during/just after dragging
        //   if (!isDragging && setMenuOpen) {
        //     setMenuOpen(!menuOpen);
        //   }
        // }}
        onClick={() => {
          if (selectProps) {
            if (
              selectProps.callSearchEndpointOnClick &&
              (!selectProps.searchString ||
                (selectProps.searchString &&
                  typeof selectProps.searchString === "string" &&
                  selectProps.searchString.trim() === "")) &&
              selectProps.parsedSearchEndpoint &&
              selectProps.fetchResults
            ) {
              selectProps.fetchResults("", selectProps.parsedSearchEndpoint);
            }
          }
        }}
      >
        {orderingComponent && orderingComponent}
        {props.children}
      </div>
    </components.Control>
  );
};

const CustomOption: React.FC<any> = props => {
  const { innerProps, innerRef } = props;
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className={`CustomOption ${props.selectProps.selectProps.fieldName} ${
        props.isSelected ? "Active" : ""
      }`}
      key={`custom-option-${props.selectProps.selectProps.fieldName}-${props.label}`}
    >
      <div className="Checkbox">
        <div className={`Radio`} role="radio" aria-checked={props.isSelected}>
          <input
            id={`custom-option-${props.selectProps.selectProps.fieldName}-${props.value}`}
            type="radio"
            name={`${props.selectProps.selectProps.fieldName}-${props.value}`}
            value=""
            disabled={false}
            onChange={() => {}} // Stop warning in console
            checked={props.isSelected}
          />
          <label
            className={`CustomInput`}
            htmlFor={`custom-option-${props.value}`}
          ></label>
        </div>
      </div>

      <div className="Label">{props.label ? props.label : ""}</div>
    </div>
  );
};

const CustomValue: React.FC<any> = props => {
  return (
    <components.SingleValue {...props}>
      <div className="ValueContainer">
        <div className="CustomValueContainer">{props.children}</div>
        <div className="Delete" onClick={props.selectProps.selectProps.remove}>
          <svg
            height="14"
            width="14"
            viewBox="0 0 20 20"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
          </svg>
        </div>
      </div>
    </components.SingleValue>
  );
};

type OrderingProps = {
  onDragEnd: (result: DropResult, provided: ResponderProvided) => void;
  isDragging: boolean;
  setIsDragging: React.Dispatch<SetStateAction<boolean>>;
  selectedOptions: SelectOptionOrderNumbers[] | null;
  onDelete: (index: number) => void;
  isMulti?: boolean;
};

const Ordering: React.FC<OrderingProps> = ({
  onDragEnd,
  isDragging,
  setIsDragging,
  selectedOptions,
  onDelete,
  isMulti,
}) => {
  const getListStyle = (isDraggingOver: any) => ({
    margin: "0 0 0 0",
  });

  return (
    <DragDropContext
      onDragEnd={onDragEnd}
      onDragStart={() => setIsDragging(true)}
    >
      <Droppable droppableId="droppable">
        {(provided, snapshot) => (
          <div
            className={`Ordering  ${isDragging ? "Dragging" : ""}`}
            {...provided.droppableProps}
            ref={provided.innerRef}
            style={getListStyle(snapshot.isDraggingOver)}
          >
            {isMulti &&
              selectedOptions &&
              selectedOptions.map((item, idx) => {
                return (
                  <div className={`OrderingContainer`}>
                    <Draggable
                      draggableId={`draggable-${idx}`}
                      key={`draggable-${idx}`}
                      index={idx}
                    >
                      {(provided, snapshot) => (
                        <div
                          className="SelectedOption"
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                          )}
                        >
                          <div className="Drag" {...provided.dragHandleProps}>
                            <img
                              src={dragIcon}
                              alt="drag option"
                              className="DragIcon"
                            />
                          </div>

                          <div className="Label">{item.label}</div>

                          <div
                            className="Delete"
                            // This causes a double delete, we only need onPointerDown so that it works on both mobile and desktop
                            // onClick={() => onDelete(idx)}
                            onPointerDown={e => {
                              e.stopPropagation(); // Stops double-clicking
                              onDelete(idx);
                            }} // mobile
                          >
                            <svg
                              className="DeleteSVG"
                              height="14"
                              width="14"
                              viewBox="0 0 20 20"
                              aria-hidden="true"
                              focusable="false"
                            >
                              <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
                            </svg>
                          </div>
                        </div>
                      )}
                    </Draggable>
                  </div>
                );
              })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

const sortOptionsAlphabetically = (options: SelectOptionOrderNumbers[]) => {
  return options.sort((a, b) => a.label.localeCompare(b.label));
};

export function SingleSelectSearchListOrderNumbers(props: {
  isMulti?: boolean;
  name: string;
  dataSource: string | null;
  showUseDefaultValues?: boolean;
  useDefaultValue?: boolean;
  limitOptionsToDefaultValue?: boolean;
  searchEndpoint?: string | { [key: string]: string };
  textToDisplayAtTop?: string;
  callSearchEndpointOnClick?: boolean;
}) {
  const [field] = useField<SelectOptionOrderNumbers[]>(props.name);
  const [options, setOptions] = useState<SelectOptionOrderNumbers[] | null>(
    null
  );
  const [
    selectedOption,
    setSelectedOption,
  ] = useState<SelectOptionOrderNumbers | null>(null);

  const [selectedOptions, setSelectedOptions] = useState<
    SelectOptionOrderNumbers[] | null
  >(null);
  const [initialOption, setInitialOption] = useState<{
    label: string;
    value: number | null;
    orderNumber: number;
  }>({
    label: "",
    value: null,
    orderNumber: -1,
  });
  const [defaultValue, setDefaultValue] = useState<any>(null);
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [parsedSearchEndpoint, setParsedSearchEndpoint] = useState<
    string | null
  >(null);
  const [searchString, setSearchString] = useState("");
  const [isDragging, setIsDragging] = useState<boolean>(false);

  useEffect(() => {
    if (props.searchEndpoint) {
      if (
        typeof props.searchEndpoint === "object" &&
        props.searchEndpoint.hasOwnProperty(props.name)
      ) {
        setParsedSearchEndpoint(
          props.searchEndpoint[props.name as keyof typeof props.searchEndpoint]
        );
      } else if (typeof props.searchEndpoint === "string") {
        setParsedSearchEndpoint(props.searchEndpoint);
      }
    }
  }, [props.searchEndpoint]);

  const bind = customUseOnClickOutside(() => setMenuOpen(false), true);

  const {
    values: formikValues,
    setTouched,
    touched: formikTouched,
    setFieldValue,
    errors,
    submitCount,
  } = useFormikContext<{
    [key: string]: any;
  }>();
  const formikErrors = errors;

  let relevantFormikError = null;

  if (formikErrors.hasOwnProperty(field.name) && submitCount > 0) {
    const error = formikErrors[field.name as keyof typeof formikErrors];

    if (typeof error === "string") {
      relevantFormikError =
        formikErrors[field.name as keyof typeof formikErrors];
    }
  }

  useEffect(() => {
    let tempInitialOption = {
      label: "",
      value: null,
      orderNumber: -1,
    };

    if (field && typeof field === "object" && field.hasOwnProperty("value")) {
      if (typeof field.value === "number") {
        tempInitialOption["value"] = field.value;
      }
    }

    const dataSource = props.dataSource;

    if (
      formikValues &&
      typeof formikValues === "object" &&
      dataSource &&
      formikValues.hasOwnProperty(dataSource) &&
      Array.isArray(formikValues[dataSource as keyof typeof formikValues])
    ) {
      const data = formikValues[dataSource as keyof typeof formikValues];

      if (data && Array.isArray(data)) {
        const tempOptions = data.map(
          (item: SelectOptionOrderNumbers, idx: number) => {
            if (
              typeof tempInitialOption.value === "number" &&
              item.value === tempInitialOption.value
            ) {
              tempInitialOption["label"] = item.label;
            }

            return {
              label: item.label,
              value: item.value,
              orderNumber: item.orderNumber ?? -1,
            };
          }
        );

        setOptions(sortOptionsAlphabetically(tempOptions));
        setInitialOption(tempInitialOption);

        if (props.useDefaultValue) {
          const defaultValueFieldName = `default${capitaliseFirstLetter(
            field.name
          )}`;

          if (formikValues.hasOwnProperty(defaultValueFieldName)) {
            const defaultValueData: any =
              formikValues[defaultValueFieldName as keyof typeof formikValues];

            const dataSourceMatch = data.filter(
              item => item.value && item.value === defaultValueData
            );

            if (
              dataSourceMatch.length === 1 &&
              typeof dataSourceMatch[0] === "object" &&
              dataSourceMatch[0].hasOwnProperty("label") &&
              dataSourceMatch[0].hasOwnProperty("value") &&
              dataSourceMatch[0].hasOwnProperty("orderNumber")
            ) {
              const tempDefaultValue = {
                label: dataSourceMatch[0].label,
                value: dataSourceMatch[0].value,
                orderNumber: dataSourceMatch[0].orderNumber,
              };

              setDefaultValue(tempDefaultValue);

              // Only use default value if we haven't already set an initial option from previously selected options above
              if (!tempInitialOption.value) {
                setInitialOption(tempDefaultValue);
              }
            }
          }
        }
      }
    } else if (
      formikValues &&
      typeof formikValues === "object" &&
      dataSource &&
      formikValues.hasOwnProperty(dataSource)
    ) {
      setOptions([]);
    }

    if (
      tempInitialOption.label !== "" &&
      typeof tempInitialOption.value === "number" &&
      selectedOption === null
    ) {
      setSelectedOption(tempInitialOption);
    }
  }, []);

  useEffect(() => {
    if (
      initialOption &&
      initialOption.label !== "" &&
      initialOption.value !== null &&
      !selectedOption
    ) {
      setSelectedOption(initialOption);

      setFieldValue(field.name, initialOption);
    }
  }, [initialOption]);

  useEffect(() => {
    if (defaultValue) {
      if (props.limitOptionsToDefaultValue) {
        setOptions(sortOptionsAlphabetically([defaultValue]));

        if (
          initialOption.label !== defaultValue.label &&
          initialOption.value !== defaultValue.value
        ) {
          setOptions(sortOptionsAlphabetically([defaultValue, initialOption]));
        } else {
          setOptions(sortOptionsAlphabetically([defaultValue]));
        }
      }

      if (!selectedOption) {
        setSelectedOption(defaultValue);

        setFieldValue(field.name, defaultValue);
      }
    }
  }, [defaultValue]);

  // Make sure field value is in the list of options, if not, set to default value or empty value
  useEffect(() => {
    if (
      options &&
      Array.isArray(options) &&
      options.length > 0 &&
      options[0].hasOwnProperty("value") &&
      field.value
    ) {
      if (props.isMulti) {
        if (field.value.length >= 1) {
          const sortedValueMatch = sortByOrderNumber(field.value);

          if (!compareArrayofObjects(selectedOptions, sortedValueMatch)) {
            // if (selectedOptions !== sortedValueMatch) {

            setSelectedOptions(sortByOrderNumber(field.value));
          }
        } else {
          if (!selectedOptions) {
            setSelectedOptions(null);
          }

          if (!field.value) {
            setFieldValue(field.name, null);
          }
        }
      }
    }
  }, [field]);

  const onChange = (v: SelectOptionOrderNumbers) => {
    setSelectedOption(v);

    let finalValue = v;

    if (typeof v.value === "string") {
      finalValue.value = parseInt(v.value);
    }

    setFieldValue(field.name, finalValue);
  };

  const onChangeMulti = (v: SelectOptionOrderNumbers[]) => {
    setSelectedOptions(sortByOrderNumber(v));

    let finalValues = [...v];

    v.forEach((item, idx) => {
      if (typeof item.value === "string") {
        finalValues[idx].value = parseInt(item.value);
      } else {
        finalValues[idx].value = parseInt(item.value);
      }
    });

    setFieldValue(field.name, sortByOrderNumber(finalValues));
  };

  useEffect(() => {
    setMenuOpen(false);
  }, [selectedOption]);

  const fetchResults = async (
    searchString: string,
    parsedSearchEndpoint: string
  ) => {
    if (parsedSearchEndpoint) {
      try {
        const results = await api.get(parsedSearchEndpoint, {
          params: { searchString },
        });

        let options: SelectOptionOrderNumbers[] | null = null;

        if (
          results &&
          results.data &&
          results.data.status === "1" &&
          results.data.details.results &&
          Array.isArray(results.data.details.results)
        ) {
          options = results.data.details.results;
        }

        setOptions(options ? sortOptionsAlphabetically(options) : null);
      } catch (error) {
        // Error case
        console.log("fetchResults error", error);
      }
    }
  };

  const getSearchResults = useCallback(debounce(fetchResults, 500), []);

  const onFilter = (e: any) => {
    e.preventDefault();
    let inputString = e.target.value;
    if (e.target.value === "") {
      setSearchString("");
      setDefaultOpts();
    } else {
      setSearchString(inputString);
      let tempOptions =
        formikValues[
          props.dataSource as keyof typeof formikValues
        ].filter((opt: SelectOptionOrderNumbers) =>
          opt.label.toLowerCase().includes(inputString.toLowerCase())
        ) ?? null;
      setOptions(tempOptions ? sortOptionsAlphabetically(tempOptions) : null);
    }
  };

  const onSearch = (e: any) => {
    e.preventDefault();
    if (!e.target.value) {
      setSearchString("");
      setDefaultOpts();
    } else if (parsedSearchEndpoint && e.target.value) {
      setSearchString(e.target.value);
      getSearchResults(e.target.value, parsedSearchEndpoint);
    }
  };

  const Remove = () => {
    setSelectedOption(null);
    setFieldValue(props.name, null);
  };

  const setDefaultOpts = () => {
    if (
      props.dataSource &&
      formikValues &&
      formikValues.hasOwnProperty(props.dataSource)
    ) {
      const data = formikValues[
        props.dataSource as keyof typeof formikValues
      ] as SelectOptionOrderNumbers[];
      setOptions(data ? sortOptionsAlphabetically(data) : []);
    }
  };

  useOnceAfterCondition(
    () => {
      if (!selectedOption) return;

      if (!Array.isArray(selectedOption)) {
        const startOps = options?.filter(
          opt => selectedOption.value === opt.value
        );

        setSelectedOption(
          startOps &&
            startOps.length === 1 &&
            typeof startOps[0] === "object" &&
            startOps[0].hasOwnProperty("value")
            ? startOps[0]
            : null
        );
      }
    },
    [options],
    options
  );

  const filterOption = (option: Option, rawInput: string) => {
    // Return true for all options as we are already filtering when calling the search endpoint. We don't need to filter twice
    return true;
  };

  const onDragEnd = async (result: DropResult) => {
    if (!result.destination) {
      return;
    }

    if (
      result.source &&
      result.source.hasOwnProperty("index") &&
      result.destination &&
      result.destination.hasOwnProperty("index") &&
      selectedOptions
    ) {
      const items = reorder(
        selectedOptions,
        result.source.index,
        result.destination.index
      );

      let newSelectedOptions = items.map((item, idx) => {
        return { ...item, orderNumber: idx };
      });

      newSelectedOptions = sortByOrderNumber(newSelectedOptions);

      setSelectedOptions(newSelectedOptions);

      setFieldValue(field.name, newSelectedOptions);
    }

    setIsDragging(false);
  };

  const grid =
    selectedOptions && Array.isArray(selectedOptions)
      ? selectedOptions.length
      : 0;

  const getListStyle = (isDraggingOver: any) => ({
    padding: grid,
    margin: " 0 0 0 0",
  });

  const onDelete = (index: number) => {
    let finalValues = selectedOptions ? [...selectedOptions] : [];

    if (
      finalValues &&
      Array.isArray(finalValues) &&
      finalValues.length >= index + 1
    ) {
      finalValues.splice(index, 1);
    }

    finalValues = finalValues.map((item, idx) => {
      return { ...item, orderNumber: idx };
    });

    setSelectedOptions(finalValues);

    setFieldValue(field.name, finalValues);
  };

  if (options) {
    return (
      <div className="FormField">
        <div
          className={`EditSingleSelectFieldContainer SearchListRenderer SingleSelectSearchListOrderNumbers ${
            relevantFormikError ? "Error" : ""
          } ${field.name}`}
          {...bind}
        >
          {props.textToDisplayAtTop && (
            <div className="TextToDisplayAtTop">{props.textToDisplayAtTop}</div>
          )}

          <Select
            className={`CustomSelect EditSingleSelect SearchListRenderer ${
              !props.isMulti ? "Single" : ""
            }`}
            classNamePrefix={`CustomSelect${
              relevantFormikError ? "Error" : ""
            }`}
            options={options ?? []}
            value={
              props.isMulti
                ? selectedOptions
                : selectedOption
                ? selectedOption
                : field.value
            }
            onChange={
              props.isMulti
                ? (onChangeMulti as (
                    selectedOption: ValueType<SelectOptionOrderNumbers, any>
                  ) => // selectedOption: ValueType<SelectOptionOrderNumbers, any>
                  void)
                : (onChange as (
                    selectedOption: ValueType<SelectOptionOrderNumbers, any>
                  ) => void)
            }
            hideSelectedOptions={false} // Keep selected options in the menu
            selectProps={{
              menuOpen: menuOpen,
              setMenuOpen: setMenuOpen,
              remove: Remove,
              isDragging: isDragging,
              orderingComponent: (
                <Ordering
                  onDragEnd={onDragEnd}
                  isDragging={isDragging}
                  setIsDragging={setIsDragging}
                  selectedOptions={selectedOptions}
                  onDelete={onDelete}
                  isMulti={props.isMulti}
                />
              ),
              searchString,
              parsedSearchEndpoint,
              fetchResults,
              callSearchEndpointOnClick: props.callSearchEndpointOnClick,
            }}
            isMulti={props.isMulti ?? false}
            filterOption={parsedSearchEndpoint ? filterOption : undefined}
            isSearchable={false}
            menuIsOpen={menuOpen}
            onMenuOpen={() => {
              setMenuOpen(true); // NOTE: This is needed to make click on mobile phones work
            }}
            onMenuClose={() => {
              // setMenuOpen(false); // NOTE: This is needed to make click on mobile phones work
            }}
            noOptionsMessage={() => "No options"}
            placeholder={false}
            closeMenuOnSelect={false}
            components={{
              Option: CustomOption,
              Control: CustomControl,
              SingleValue: CustomValue,
            }}
            onBlur={() => {
              let newTouched = { ...formikTouched };
              newTouched[props.name] = true;
              setTouched(newTouched);
            }}
            styles={{
              multiValue: (styles, { data }) => {
                return {
                  ...styles,
                  backgroundColor: "#DEEBFF",
                  color: "#4C9AFF",
                };
              },
              multiValueLabel: (styles, { data }) => ({
                ...styles,
                color: "#4C9AFF",
                fontSize: "1.1rem",
              }),
              multiValueRemove: (styles, { data }) => ({
                ...styles,
                color: "#4C9AFF",
                ":hover": {
                  backgroundColor: "red",
                  color: "white",
                },
              }),
            }}
            backspaceRemovesValue={false} // Prevent backspace key presses deleting selected items
          />

          <div className={`${menuOpen ? "behind" : "hide"}`}>
            <input
              className="custom-input-search"
              value={parsedSearchEndpoint ? searchString : undefined}
              onChange={parsedSearchEndpoint ? onSearch : onFilter}
              placeholder="Type search here"
              onFocus={() => {
                let newTouched = { ...formikTouched };
                newTouched[props.name] = false;
                setTouched(newTouched);
              }}
              onBlur={() => {
                let newTouched = { ...formikTouched };
                newTouched[props.name] = true;
                setTimeout(() => {
                  setTouched(newTouched);
                }, 100);
              }}
            />
          </div>
          {props.showUseDefaultValues && (
            <div
              className={`UseDefaultValuesBtn Btn ${
                !selectedOption ? "Disabled" : ""
              }`}
              onClick={() => {
                if (selectedOption && selectedOption.value) {
                }
              }}
            >
              <div className="Text">Use Default Values</div>
            </div>
          )}
          {relevantFormikError && (
            <div className="ErrorLabel">{relevantFormikError}</div>
          )}
        </div>
      </div>
    );
  } else {
    return (
      <div
        className={`EditSingleSelectFieldContainer ${
          relevantFormikError ? "Error" : ""
        }`}
      >
        <div className="EditBox ViewOnly NoOptions">Error: No data</div>

        {relevantFormikError && (
          <div className="ErrorLabel">{relevantFormikError}</div>
        )}
      </div>
    );
  }
}
